(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cotigo-product-badges"] && !Shopify.designMode) return;
  try {
    (() => {
  const records = new WeakMap();
  let clock = null;
  let syncing = false;
  const summary = (variants, now) => {
    let min = 100, max = 0, sale = false;
    for (const [native, reduced, offers] of variants) {
      let percent = native, active = reduced;
      if (now !== null) {
        for (const [amount, start, end, freshUntil] of offers) {
          if (now >= start && now < end && (!freshUntil || now < freshUntil)) {
            percent = amount; active = true;
          }
        }
      }
      min = Math.min(min, percent); max = Math.max(max, percent); sale ||= active;
    }
    return {min, max, sale};
  };
  const render = () => {
    const now = clock ? clock() / 1000 : null;
    for (const root of document.querySelectorAll('[data-cotigo-badges]')) {
      if (!records.has(root)) {
        try { records.set(root, JSON.parse(root.dataset.discountVariants)); }
        catch (_) { continue; }
      }
      const {min, max, sale} = summary(records.get(root), now);
      const label = max <= 0 ? root.dataset.badgeSale : min === max ? `−${max}%` : root.dataset.badgeUpTo.replace('__P__', max);
      const text = root.querySelector('[data-discount-label]');
      if (text && text.textContent !== label) text.textContent = label;
      let shown = 0;
      for (const badge of root.querySelectorAll('[data-badge-kind]')) {
        const kind = badge.dataset.badgeKind;
        const manual = kind === 'new' ? root.dataset.badgeManualNew === 'show' : kind === 'bestseller' && root.dataset.badgeManualHot === 'show';
        const expiredHot = !manual && (kind === 'bestseller' || kind === 'new') && now !== null && now >= Number(root.dataset.badgeHotExpiry);
        badge.hidden = shown >= 2 || kind === 'sale' && !sale || expiredHot;
        if (!badge.hidden) shown++;
      }
    }
  };
  const sync = async () => {
    if (syncing || document.hidden || !document.querySelector('[data-cotigo-badges]')) return;
    syncing = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js?_cotigo_badge_clock=${Date.now()}`, {cache:'no-store', credentials:'same-origin'});
      const epoch = Date.parse(response.headers.get('date'));
      response.body?.cancel().catch(() => {});
      if (!response.ok || !Number.isFinite(epoch)) throw new Error('Clock unavailable');
      const received = performance.now();
      clock = () => epoch + performance.now() - received;
    } catch (_) {
      // Native markdowns remain valid; unverified timed offers stay hidden.
    } finally { syncing = false; render(); }
  };
  new MutationObserver(changes => {
    if (changes.some(change => [...change.addedNodes].some(node => node instanceof Element && (node.matches('[data-cotigo-badges]') || node.querySelector('[data-cotigo-badges]'))))) {
      render(); if (!clock) sync();
    }
  }).observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });
  setInterval(() => { if (!document.hidden) render(); }, 1000);
  setInterval(sync, 60000);
  render(); sync();
})();
  } catch(e) { console.error(e); }
})();

})();
